import React, { useState } from "react";
import ScrollToTop from "./ScrollToTop";
import MotionController from "./MotionController";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./pages/home";
import Services from "./pages/services";
import Service1 from "./pages/service1";
import Service2 from "./pages/service2";
import Service3 from "./pages/service3";
import Service4 from "./pages/service4";
import Portfolio from "./pages/portfolio";
import About from "./pages/about";
import Contact from "./pages/contact";
import "./App.css";
import logo from "./images/logo/pwb-logo.svg"
import logoWhite from "./images/logo/pwb-logo-white.svg"
import facebook from "./images/social-icons/facebook.svg"
import line from "./images/social-icons/line.svg"
import lazada from "./images/social-icons/lazada.svg"
import shopee from "./images/social-icons/shopee.svg"

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <Router>
      <div className={`app ${menuOpen ? "menu-open" : ""}`}>
        {/* Header with Navigation */}
        <header className="header">
          <Link  to="/" className="logo" onClick={() => setMenuOpen(false)}>
          <img src={logo} alt="POWER BUNCH" className="logo-img" />
          </Link>
          <button className="menu-btn" onClick={toggleMenu}>
            ☰
          </button>
          <nav className={`navbar ${menuOpen ? "open" : ""}`}>
            <ul>
              <li><Link to="/services" onClick={() => setMenuOpen(false)}>บริการของเรา</Link></li>
              <li><Link to="/portfolio" onClick={() => setMenuOpen(false)}>ผลงานตัวอย่าง</Link></li>
              <li><Link to="/about" onClick={() => setMenuOpen(false)}>เกี่ยวกับเรา</Link></li>
              <li><Link to="/contact" onClick={() => setMenuOpen(false)}>ช่องทางติดต่อ</Link></li>
            </ul>
          </nav>
        </header>

        {/* Main Content */}
        <main className="main-content">
          <ScrollToTop />
          <MotionController />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />}/>
            <Route path="/service1" element={<Service1 />} />
            <Route path="/service2" element={<Service2 />} />
            <Route path="/service3" element={<Service3 />} />
            <Route path="/service4" element={<Service4 />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>

        {/* Footer */}
        <footer className="footer">
          <div className="footer-container">
            <div className="footer-container-logo">
              <img src={logoWhite} alt="POWER BUNCH" className="footer-logo-img" />
              
              <div className="footer-social-container">
                <a href="https://www.facebook.com/profile.php?id=61550302584763" target="_blank" rel="noopener noreferrer">
                  <img src={facebook} alt="Facebook" className="social-icon" />
                </a>
                <a href="https://line.me/ti/p/~srt6767" target="_blank" rel="noopener noreferrer">
                  <img src={line} alt="line" className="social-icon" />
                </a>
                <a href="https://www.lazada.co.th/shop/factory-outlet-shop-fos/" target="_blank" rel="noopener noreferrer">
                  <img src={lazada} alt="lazada" className="social-icon" />
                </a>
                <a href="https://shopee.co.th/nichdaso?entryPoint=ShopBySearch&searchKeyword=factoryoutletshop" target="_blank" rel="noopener noreferrer">
                  <img src={shopee} alt="shopee" className="social-icon" />
                </a>
              </div>
            </div>

            <div className="footer-container-nav">
              <ul>
                <h4>บริการของเรา</h4>
                <Link to="/service1">
                <li>ติดตั้งระบบดูดอากาศในห้องครัว</li>
                </Link>
                <Link to="/service2">
                <li>ติดตั้งระบบแก๊สและความปลอดภัย</li>
                </Link>
                <Link to="/service3">
                <li>ผลิตและนำเข้าเครื่องครัวครบวงจร</li>
                </Link>
                <Link to="/service4">
                <li>งานผลิตสแตนเลสและเหล็กตามแบบ</li>
                </Link>
              </ul>

              <ul>
                <h4>ข้อมูลของเรา</h4>
                <Link to="/about">
                <li>เกี่ยวกับเรา</li>
                </Link>
                <Link to="/contact">
                <li>ช่องทางติดต่อ</li>
                </Link>        
              </ul>
            </div>
          </div>
          <p style={{marginTop : '20px'}}>© 2025 Power Bunch. สงวนลิขสิทธิ์</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
